var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6663 14.0003C25.6663 20.4438 20.4432 25.667 13.9997 25.667C7.55618 25.667 2.33301 20.4438 2.33301 14.0003C2.33165 12.1889 2.75275 10.4021 3.56284 8.78191C4.37294 7.16171 5.54971 5.75276 6.99968 4.66699L6.99968 7.82866C5.81173 9.17589 5.03776 10.8373 4.77064 12.6135C4.50353 14.3897 4.75461 16.2052 5.49376 17.8423C6.23291 19.4793 7.42873 20.8683 8.93773 21.8426C10.4467 22.8168 12.2048 23.335 14.001 23.3348C15.7971 23.3347 17.5551 22.8162 19.064 21.8417C20.5728 20.8672 21.7684 19.478 22.5073 17.8409C23.2461 16.2037 23.4969 14.3881 23.2295 12.612C22.9621 10.8358 22.1878 9.17453 20.9997 7.82749L20.9997 4.66583C22.4498 5.75171 23.6267 7.16085 24.4368 8.78126C25.2469 10.4017 25.6679 12.1887 25.6663 14.0003ZM18.6663 5.83366L15.1663 5.83366L15.1663 15.167L12.833 15.167L12.833 5.83366L9.33301 5.83366L13.9997 0.000325647L18.6663 5.83366Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bb4c3aaad5548ed444a8cbca0b1d3826.svg";
export { ForwardRef as ReactComponent };